export default {
  styleOverrides: {
    elevation1: {
      boxShadow: "0 1px 6px 0 rgba(0, 0, 0, 0.16)",
    },
  },
};
